import {
  GraphQLInputObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLList
} from 'graphql'
import { dateTimeType } from './date-time-type'

export interface RouteCoverageFilterArg {
  readonly filterText?: string
  readonly quickFilter?: string
  readonly dateFilter?: RouteDateFilter
  readonly discoveredDateFilter?: RouteDateFilter
  readonly applications?: string[]
  readonly agentSessionId?: string[]
}

interface RouteDateFilter {
  readonly start: Date
  readonly end: Date
}

const routeDateFilterType = new GraphQLInputObjectType({
  name: 'RouteDateFilter',
  description: 'Options for filtering routes using a date range',
  fields: () => ({
    start: {
      description: 'Filter with a date range starting from this date',
      type: new GraphQLNonNull(dateTimeType)
    },
    end: {
      description: 'Filter with a date range ending at this date',
      type: new GraphQLNonNull(dateTimeType)
    }
  })
})

const filterList = new GraphQLList(GraphQLString)

export const routeCoverageFilterArgType = new GraphQLInputObjectType({
  name: 'RouteCoverageFilterArg',
  description:
    'A collection of criteria categories and values to filter routes by. Each criteria category consists of a list of strings. Categories of criteria are applied with an AND relationship. Within each category, the individual criteria values are applied with an OR relationship',
  fields: () => ({
    filterText: {
      description:
        'Filter routes that have signatures that contain the specified text string',
      type: GraphQLString
    },
    quickFilter: {
      description: 'An optional predefined filter',
      type: GraphQLString
    },
    dateFilter: {
      description: 'Filter routes by a date range',
      type: routeDateFilterType
    },
    discoveredDateFilter: {
      description: 'Filter routes by a first seen date',
      type: routeDateFilterType
    },
    applications: {
      description: 'Filters routes by application IDs',
      type: filterList
    },
    agentSessionId: {
      description: 'Filters routes by session',
      type: filterList
    }
  })
})
